import { takeLatest, put, call } from 'redux-saga/effects';

import { listCentroCustoCadastro } from '../service';
import {
  TABLE_CENTRO_CUSTO_CADASTRO,
  TABLE_CENTRO_CUSTO_CADASTRO_PENDING,
  TABLE_CENTRO_CUSTO_CADASTRO_SUCCESS,
  TABLE_CENTRO_CUSTO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListCentroCustoCadastro(action) {
  yield put({ type: TABLE_CENTRO_CUSTO_CADASTRO_PENDING })

  try {
    const table = yield call(listCentroCustoCadastro, action.args)
    yield put({ type: TABLE_CENTRO_CUSTO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CENTRO_CUSTO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListCentroCustoCadastro() {
  yield takeLatest(TABLE_CENTRO_CUSTO_CADASTRO, sagaListCentroCustoCadastro)
}